<template>
  <div :class="'seat-info block-info seat-component ' + seatClass">
    <span v-if="isSelected" class="seat-info-initials">{{
      displayPassengerInitials
    }}</span>
    <vb-icon v-else-if="isBlocked" name="seat_blocked"></vb-icon>
    <vb-icon
      v-else-if="
        !isSelected &&
        isAvailable &&
        isSuitableForInfant &&
        (!isHovered || price === 0)
      "
      class="seat-info-price"
      name="seat_best_for_infant"
      :color="sass('primary')"
      :size="20"
    ></vb-icon>
    <span
      v-else-if="
        !isSelected &&
        isAvailable &&
        price !== 0 &&
        (!isSuitableForInfant || isHovered)
      "
      class="seat-info-price"
    >
      <span>{{ formattedPrice }}</span>
      <span class="d-none d-xl-inline d-lg-inline">{{ currencySymbol }}</span>
    </span>
  </div>
</template>

<script>
export default {
  name: 'SeatContent',
  props: {
    seatClass: {
      type: String,
      required: true,
    },
    isSelected: {
      type: Boolean,
      default: false,
    },
    isBlocked: {
      type: Boolean,
      default: false,
    },
    isAvailable: {
      type: Boolean,
      default: false,
    },
    isSuitableForInfant: {
      type: Boolean,
      default: false,
    },
    isHovered: {
      type: Boolean,
      default: false,
    },
    price: {
      type: Number,
      default: 0,
    },
    // Pre-resolved glyph (€, $, …) — computed in the seat-map mapper from
    // the seat-pricing response's currency code, so template renders stay
    // allocation-free.
    currencySymbol: {
      type: String,
      default: '',
    },
    passenger: Object,
  },
  computed: {
    displayPassengerInitials() {
      if (!this.passenger) return ''
      return 'P' + this.passenger.id
    },
    formattedPrice() {
      return Math.ceil(this.price)
    },
  },
  methods: {
    sass(colorName) {
      // Pass through to parent's sass helper
      return this.$parent.sass ? this.$parent.sass(colorName) : colorName
    },
  },
}
</script>
